import React from 'react'
import './hero.css'

export default function Hero() {
  return (
    <div className=' d-flex '>
      <div className='HeroSection'>

        <div className='w-75 text-Section '>
          <h3 className='embossed '>PREMIUM AUTOMOTIVE CARE
           <br /> SOLUTIONS <br />
          
          </h3>
         

        </div>
      </div>

    </div>
  )
}
